import { memoize } from "../../../utils";

export const loadTone = memoize(async () => await import("tone"));
